/**
 * 编辑地址相关文案
 */
export default {
  addressForm: {
    name: {
      label: 'Full Name',
      placeholder: 'Recipient (Parent/Guardian Name)',
    },
    phone: {
      label: 'Mobile Number',
      placeholder: 'Mobile Number',
    },
    postcode: {
      label: 'Postcode',
      placeholder: 'Postcode',
    },
    address1: {
      label: 'Address Line 1',
      placeholder: 'Detailed Address',
    },
    address2: {
      label: 'Address Line 2',
      placeholder: 'Address Line 2 (optional)',
    },
  },
}
